import { useEffect, useState } from 'react';
import { CurrencyIcon } from '~/components/collections';
import { TextInput } from '~/components/ui/TextInput';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { StyledContainer } from './MoneyInput.styled';

const MoneyInput = ({
	value,
	onChange,
	placeholder,
	height = 40,
	fontSize = 14,
	padding = '0 44px 0 15px',
	icon,
}: {
	value: number;
	onChange: (newValue: number) => void;
	placeholder?: string;
	height?: number;
	fontSize?: number;
	padding?: string;
	icon?: string;
}) => {
	const [inputValue, setInputValue] = useState<number>(value || 0);
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const inputValue = e.target.value.replace(/\D/g, '');

		if (inputValue.length === 0) {
			setInputValue(0);
			onChange(0);
			return;
		}

		setInputValue(parseInt(inputValue));
		onChange(parseInt(inputValue));
	};

	useEffect(() => {
		setInputValue(value ?? 0);
	}, [value]);

	return (
		<StyledContainer>
			<TextInput
				height={height}
				fontSize={fontSize}
				padding={padding}
				onChange={handleChange}
				value={inputValue ? inputValue.toLocaleString('ru-RU') : ''}
				placeholder={placeholder}
			/>
			{icon ? (
				<img src={icon} width={14} height={14} />
			) : (
				<CurrencyIcon icon={rubleIcon} size="sm" />
			)}
		</StyledContainer>
	);
};

export { MoneyInput };
